module.exports = function() {
  return new Worker(__webpack_public_path__ + "c7c423212575ddcbacfb.worker.js");
};